import { Component, Input } from '@angular/core';

@Component({
  selector: 'rs-popup',
  templateUrl: 'popup.component.html',
  styleUrls: ['popup.component.scss']
})
export class PopupComponent {

  @Input() caption: string;

}
